export const inputTheme = {
  paddingBlockLG: 13,
  paddingInlineLG: 20,
  activeShadow: "",
  inputFontSizeLG: 14,
};

export const inputNumberTheme = {};
